import { render, staticRenderFns } from "./QuotesModal.vue?vue&type=template&id=ec22000a&scoped=true&"
import script from "./QuotesModal.vue?vue&type=script&lang=js&"
export * from "./QuotesModal.vue?vue&type=script&lang=js&"
import style0 from "./QuotesModal.vue?vue&type=style&index=0&id=ec22000a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec22000a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec22000a')) {
      api.createRecord('ec22000a', component.options)
    } else {
      api.reload('ec22000a', component.options)
    }
    module.hot.accept("./QuotesModal.vue?vue&type=template&id=ec22000a&scoped=true&", function () {
      api.rerender('ec22000a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JobOffers/QuotesModal.vue"
export default component.exports